import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import styled from 'styled-components';

const WhatsAppContainer = styled.div`
  position: fixed;
  bottom: 100px; // Reduced distance from chat widget
  right: 23px; // Moved more to the left
  z-index: 999;
  display: ${props => props.isVisible ? 'block' : 'none'};
`;

const CloseButton = styled.button`
  position: absolute;
  top: -8px;
  right: -8px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.8);
  color: #555;
  border: 1px solid rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  cursor: pointer;
  opacity: 0.7;
  transition: all 0.2s ease;
  padding: 0;
  box-shadow: 0 1px 3px rgba(0,0,0,0.2);
  
  &:hover {
    opacity: 1;
    transform: scale(1.1);
  }
  
  &:focus {
    outline: none;
  }
`;

const WhatsAppLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #25D366; // WhatsApp green
  color: white;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);
  transition: all 0.3s ease;
  text-decoration: none;
  
  &:hover {
    transform: scale(1.1);
    box-shadow: 0 6px 14px rgba(0, 0, 0, 0.3);
    color: white;
  }
`;

const WhatsAppButton = ({ phoneNumber = "1234567890", message = "Hello, I'm interested in selling my land" }) => {
  const [isVisible, setIsVisible] = useState(true);
  
  // Retrieve visibility state from localStorage on component mount
  useEffect(() => {
    // Force visibility on for development/testing
    setIsVisible(true);
    localStorage.setItem('whatsappButtonVisible', 'true');
    
    // Check for expiry time
    const hiddenUntil = localStorage.getItem('whatsappButtonHiddenUntil');
    if (hiddenUntil && parseInt(hiddenUntil) < Date.now()) {
      // Time has passed, show button again
      setIsVisible(true);
      localStorage.removeItem('whatsappButtonHiddenUntil');
      localStorage.setItem('whatsappButtonVisible', 'true');
    }
  }, []);
  
  const handleClose = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsVisible(false);
    // Save preference to localStorage
    localStorage.setItem('whatsappButtonVisible', 'false');
    
    // Set a timeout to show the button again after some time (e.g., 7 days)
    const expiryTime = Date.now() + (7 * 24 * 60 * 60 * 1000); // 7 days in milliseconds
    localStorage.setItem('whatsappButtonHiddenUntil', expiryTime.toString());
  };
  
  const formattedPhone = phoneNumber.replace(/[^0-9]/g, '');
  const encodedMessage = encodeURIComponent(message);
  const whatsappUrl = `https://wa.me/${formattedPhone}?text=${encodedMessage}`;
  
  return (
    <WhatsAppContainer isVisible={isVisible}>
      <CloseButton onClick={handleClose} aria-label="Close WhatsApp button">
        <FontAwesomeIcon icon={faTimes} size="sm" />
      </CloseButton>
      <WhatsAppLink href={whatsappUrl} target="_blank" rel="noopener noreferrer" aria-label="Contact us on WhatsApp">
        <FontAwesomeIcon icon={faWhatsapp} size="2x" />
      </WhatsAppLink>
    </WhatsAppContainer>
  );
};

export default WhatsAppButton;
